import auth from "../../middlewares/auth";
export const noticesRoute = [
  {
    path: '/notice/list',
    component: () => import(/* webpackChunkName: "notices" */ '../../views/notices/NoticeList'),
    name: 'notice_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/notice/add',
    component: () => import(/* webpackChunkName: "notices" */ '../../views/notices/NoticeForm'),
    name: 'notice_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/notice/edit/:id',
    component: () => import(/* webpackChunkName: "notices" */ '../../views/notices/NoticeForm'),
    name: 'notice_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];